<template>
    <div class="register">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Home"></navbar>
        <!--注册页-->
        <div class="register_page">
            <Spin size="large" fix v-if="spinShow"></Spin>
            <div class="register_main">
                <img class="ifree-logo" src="../../assets/home/new_home/logo_blue@2x.png">
                <h1 class="register-title" style="font-weight: 500;">
                    {{$t('register_title')}}
                </h1>
                <p class="resgister-sm-title">{{$t('register_title1')}} </p>
                <div class="resgister-main">

                    <div class="from-input">
                        <input class="resgister-username"
                               v-validate="'required|min:5'"
                               name="register_username"
                               type="text"
                               :placeholder="$t('user_center_username')"
                               v-model="registerData.username"
                               :class="{'is-error': errors.has('register_username')}">

                    </div>
                    <div class="from-input">
                        <input class="resgister-email"
                               v-validate="'required|email'"
                               name="register_email" type="text"
                               :placeholder="$t('user_center_email')"
                               v-model="registerData.email"
                               :class="{'is-error': errors.has('register_email')}">
                    </div>
                    <div class="from-input" style="position: relative">
                        <input id="resgister-password1_1"
                               class="resgister-password"
                               v-validate="'required|min:6'"
                               name="register_password"
                               type="password"
                               :placeholder="$t('user_center_password')"
                               v-model="registerData.password"
                               :class="{'is-error': errors.has('register_password')}" v-on:focus="focus(1)"
                               @blur="focusout(1)">
                        <img v-if="showthis_1 === 'a'" src="../../assets/icon_eye.png" @click="hide(1)" width="30"
                             style="position: absolute;right: 10px;top:25px;">
                        <img v-else-if="showthis_1 === 'b'" src="../../assets/icon_hide.png" @click="show(1)" width="30"
                             style="position: absolute;right: 10px;top:25px;">
                    </div>
                    <div class="from-input" style="position: relative">
                        <input id="resgister-password2_2"
                               class="resgister-password"
                               v-validate="'required|min:6'"
                               name="register_repassword"
                               type="password"
                               :placeholder="$t('user_center_account_password_re_psw')"
                               v-model="registerData.repassword"
                               :class="{'is-error': errors.has('register_repassword')}">
                        <img v-if="showthis_2 === 'a'" src="../../assets/icon_eye.png" @click="hide(2)" width="30"
                             style="position: absolute;right: 10px;top:25px;">
                        <img v-else-if="showthis_2 === 'b'" src="../../assets/icon_hide.png" @click="show(2)" width="30"
                             style="position: absolute;right: 10px;top:25px;">
                    </div>

                </div>
                <div class="agree-slected">
                    <p  style="font-size: 14px;color: #5E6D82;text-align: left;" >
                        {{$t('login_agree')}}
                        <router-link class="text-primary" :to="{name: 'terms_of_service'}">
                            {{$t('agree_terms_of_conditions')}}
                        </router-link>
                        ,
                        <router-link :to="{name: 'privacy_policy'}" class="text-primary">{{$t('agree_privacy_policy')}}
                        </router-link>
                        {{$t('and')}}
                        <router-link :to="{name: 'terms_of_law'}" class="text-primary">{{$t('agree_terms_of_law')}}
                        </router-link>
                        .
                    </p>
                </div>
                <div class="login-register-btn">
                    <button type="button" @click="registerUser">
                        {{$t('user_center_resigster')}}
                    </button>
                </div>
                <div class="register_footer">
                    <a>
                        <router-link :to="{name:'Login'}" class="text-primary">
                            <p style="text-align: center">{{$t('login_tip1')}}</p>
                        </router-link>
                    </a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import dataImage from '../../lib/dataImage'
    import Signature from '../../lib/Signature'
    import modal from '../Common/Modal.vue'
    import navbar from '../Common/Navbar.vue'
    export default {
        data () {
            return {
                isTransparent: false,
                forget_moadl: false,
                forget_psw_email: '',
                showthis_1:'a',
                showthis_2:'a',
                wxlogin: 0,
                facebook_id:0,
                modal1:true,
                spinShow:false,
                spinShow_forget:false,
                loginData: {
                    account: '',
                    password: ''
                },
                registerData: {
                    username: '',
                    email: '',
                    password: '',
                    repassword: ''
                },
            }
        },
        components: {
            navbar
        },
        methods:{
            //登录密码显示与隐藏
            hide(id){
                if(id == 1) {
                    this.showthis_1 = 'b'
                    $('#resgister-password1_1').attr('type','text')
                }else{
                    this.showthis_2 = 'b'
                    $('#resgister-password2_2').attr('type','text')
                }
            },
            show(id){
                if(id == 1) {
                    this.showthis_1 = 'a'
                    $('#resgister-password1_1').attr('type','password')
                }else{
                    this.showthis_2 = 'a'
                    $('#resgister-password2_2').attr('type','password')
                }
            },
            //用户注册
            registerUser () {
                if (this.single1 === false) {
                    this.$Message.error(this.$t('user_message_please_argee'))
                    return false
                }
                if(!this.registerData.email||!this.registerData.password||!this.registerData.repassword||!this.registerData.username){
                    this.$Message.error(this.$t('filled_msg')
                    )
                    return false
                }

                const module = 'index.php/index/user/register'
                let self = this
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.register_type = 'email'
                data.lang = this.$i18n.locale
                data.email = this.registerData.email
                data.password = this.registerData.password
                data.password = this.registerData.repassword
                data.nickname = this.registerData.username
                self.spinShow = true
                self.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        // 注册成功
                        self.spinShow = false
                        self.$Message.success(resp.data.msg)
                        self.Local.set('users', resp.data.data)
                        let timestamp = Date.parse(new Date()) / 1000
                        self.Local.set('timeout', timestamp)
                        self.modal1 = false
                        self.$router.push({
                            name: 'Home'
                        })
                    }else{
                        self.spinShow = false
                        self.$Message.error(resp.data.msg)
                    }

                    if (parseInt(resp.data.code) === 2001) {
                        self.spinShow = false
                        self.$Message.error(resp.data.msg)
                        self.errors.has('register_email') === false
                        return false
                    }

                })
            }
        }
    }
</script>
<style lang="scss">
    @import "../../scss/_register.scss";
</style>



// WEBPACK FOOTER //
// Register.vue?ae56e442